import { Col } from "reactstrap";
import { TextColorsTitle } from "../../../../constants";
import { BorderColorData } from "../../../../data/uiKits/HelperClasses";

const TextColors = () => {
  return (
    <Col xxl="3" sm="6">
      <div className="border-wrapper h-100 dark-helper alert-light-light">
        <h3 className="mb-3">{TextColorsTitle}</h3>
        {BorderColorData &&
          BorderColorData.map((item) => (
            <div className="helper-common-box" key={item.id}>
              <div className={`helper-box border txt-${item.color} ${item.id === 8 ? "bg-dark" : ""}`}>{"C "}</div>
              <span>{`.txt-${item.color}`}</span>
            </div>
          ))}
      </div>
    </Col>
  );
};
export default TextColors;
